import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import Address from 'src/app/model/project/address';

@Injectable({
  providedIn: 'root'
})
export class ImmoIPChangesService {
  private addressSavedSuccessfullySubject = new Subject<
    AddressSavedSuccessfullyEvent
  >();

  public submitAddressSavedSuccessfully(
    subProjectId: number,
    address: Address
  ): void {
    this.addressSavedSuccessfullySubject.next({
      subProjectId: subProjectId,
      address: address
    });
  }

  public getAddressSavedSuccessfullyObservable(): Observable<
    AddressSavedSuccessfullyEvent
  > {
    return this.addressSavedSuccessfullySubject;
  }

  private addressSaveErrorSubject = new Subject<AddressSaveError>();

  public notifyAddressSaveError(
    subProjectId: number,
    error: Error,
    address?: Address
  ): void {
    const addressSaveError: AddressSaveError = {
      subProjectId: subProjectId,
      error: error,
      address: address
    };
    this.addressSaveErrorSubject.next(addressSaveError);
  }

  public getAddressSaveErrorObservable(): Observable<AddressSaveError> {
    return this.addressSaveErrorSubject;
  }
}

export interface AddressSavedSuccessfullyEvent {
  subProjectId: number;
  address: Address;
}

export interface AddressSaveError {
  subProjectId: number;
  error: Error;
  address?: Address;
}
